import { OwlCarousel as ReactOwlCarousel } from "./owlCarousel";
import { isValidArray } from "./common";
import { Fragment, useCallback, useContext, useEffect, useRef, useState } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import { ProductCardAlgolia } from "./productCardAlgolia";
import { CarouselEndCard } from "./carouselEndCard";

const MAX_ITEMS = 15;
const MAX_VISIBLE_ITEMS = 5;

export const ProductCardPopularProduct = () => {
  const { algoliaProducts } = useContext(GlobalContext);
  const [productHit, setProductHit] = useState();
  const owlRef = useRef();
  useEffect(() => {
    if (algoliaProducts && isValidArray(algoliaProducts["TRENDINGPRODUCTS"])) {
      setProductHit(algoliaProducts["TRENDINGPRODUCTS"].slice(0, MAX_ITEMS));
    } else {
      // fetchClearanceProductsAlgolia();
    }
  }, [algoliaProducts]);

  const goStart = useCallback(() => owlRef.current?.to(0, 300), []);
  const showEndCard = isValidArray(productHit) && productHit.length > MAX_VISIBLE_ITEMS;

  return (
    <Fragment>
      {isValidArray(productHit) && (
        <section className="filter-popular-section">
          <div className="container-fluid container-lg">
            <div className="row">
              <div className="col-lg-12">
                <div className="subcategory-title">
                  <h4>Popluar Products</h4>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <ReactOwlCarousel
                  ref={owlRef}
                  className="category-products owl-theme carousel-equal-height"
                  loop={false}
                  rewind={true}
                  items={MAX_VISIBLE_ITEMS}
                  margin={5}
                  nav={true}
                  dots={true}
                  autoplay={true}
                  autoplayTimeout={3000}
                  autoplayHoverPause={true}
                  responsive={{
                    0: {
                      items: 1.5,
                      margin: 10,
                    },
                    440: {
                      items: 1.5,
                    },
                    550: {
                      items: 2.5,
                    },
                    767: {
                      items: 3,
                    },
                    991: {
                      items: MAX_VISIBLE_ITEMS,
                    },
                  }}
                >
                  {productHit.map((row, index) => (
                    <div className="item" key={index}>
                      <ProductCardAlgolia data={row} catFilter={false} />
                    </div>
                  ))}
                  {showEndCard && (
                    <div className="item" key="carousel-end">
                      <CarouselEndCard onRestart={goStart} />
                    </div>
                  )}
                </ReactOwlCarousel>
              </div>
            </div>
          </div>
        </section>
      )}
    </Fragment>
  );
};
